module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: ["dof-col"],
    style: {
      paddingLeft: _vm.padding,
      paddingRight: _vm.padding
    }
  }, [_vm._t("default"), (_vm.isShowBorderRight && !_vm.isLast) ? _c('div', {
    staticClass: ["borderRight"],
    style: {
      top: _vm.borderRightPadding + 'px',
      bottom: _vm.borderRightPadding + 'px'
    }
  }) : _vm._e(), (_vm.isShowBorderBottom) ? _c('div', {
    staticClass: ["borderBottom"],
    style: {
      left: _vm.isFirst ? _vm.borderBottomPadding + 'px' : '0px',
      right: _vm.isLast ? _vm.borderBottomPadding + 'px' : '0px'
    }
  }) : _vm._e(), (_vm.isShowDelta) ? _c('div', {
    staticClass: ["delta"]
  }) : _vm._e()], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-7b6ffb66!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-numcard-col/index.vue
// module id = 646
// module chunks = 0 1